import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { InputSize } from '../../enum/input-size.enum';

@Component({
  selector: 'lib-checkbox',
  imports: [MatIcon],
  templateUrl: './checkbox.component.html',
  styleUrl: './checkbox.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxComponent {
  selected = input<boolean>(false);
  indeterminate = input<boolean>(false);
  disabled = input<boolean>(false);
  size = input<InputSize>(InputSize.large);
  checkboxClick = output<void>();
  protected readonly InputSize = InputSize;
}
